import classnames from 'classnames';
import uniqueId from 'lodash.uniqueid';

import Icon from '~/components/icon';

import styles from './Checkbox.module.css';

export interface CheckBoxProps {
  checked: boolean;
  className?: string;
  name?: string;
  onClick?: () => void;
  shouldUseUniqueId?: boolean;
  testId?: string;
}

const Checkbox: React.FC<React.PropsWithChildren<CheckBoxProps>> = ({
  checked,
  children,
  className,
  name = 'check',
  onClick,
  shouldUseUniqueId,
  testId
}) => {
  const handleClick = (event: React.SyntheticEvent<HTMLDivElement>): void => {
    event.preventDefault();
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      className={classnames(styles.tickBoxWrapper, className)}
      data-testid={testId}
      onClick={handleClick}>

			<label>
				<input
          autoComplete="off"
          data-testid={testId ? `${testId}-checkbox` : undefined}
          defaultChecked={checked}
          id={shouldUseUniqueId ? uniqueId(name) : name}
          type="checkbox" />

				<span className={styles.labelWrapper}>
					<span
            className={`${styles.checkbox} ${checked ? styles.checked : ''}`}>

						{checked ?
            <span className={styles.checkmark}>
								<Icon fill="#00182e" icon="Checkmark" />
							</span> :
            null}
					</span>
					<span className={styles.labelText}>{children}</span>
				</span>
			</label>
		</div>);

};

export default Checkbox;